const countries = [
  { ISO: "AD", label: "Andorra", code: "Andorra" },
  { ISO: "AE", label: "United Arab Emirates", code: "United Arab Emirates" },
  { ISO: "AF", label: "Afghanistan", code: "Afghanistan" },
  { ISO: "AG", label: "Antigua and Barbuda", code: "Antigua and Barbuda" },
  { ISO: "AI", label: "Anguilla", code: "Anguilla" },
  { ISO: "AL", label: "Albania", code: "Albania" },
  { ISO: "AM", label: "Armenia", code: "Armenia" },
  { ISO: "AO", label: "Angola", code: "Angola" },
  { ISO: "AQ", label: "Antarctica", code: "Antarctica" },
  { ISO: "AR", label: "Argentina", code: "Argentina" },
  { ISO: "AS", label: "American Samoa", code: "American Samoa" },
  { ISO: "AT", label: "Austria", code: "Austria" },
  { ISO: "AU", label: "Australia", code: "Australia" },
  { ISO: "AW", label: "Aruba", code: "Aruba" },
  { ISO: "AX", label: "Alland Islands", code: "Alland Islands" },
  { ISO: "AZ", label: "Azerbaijan", code: "Azerbaijan" },
  {
    ISO: "BA",
    label: "Bosnia and Herzegovina",
    code: "Bosnia and Herzegovina",
  },
  { ISO: "BB", label: "Barbados", code: "Barbados" },
  { ISO: "BD", label: "Bangladesh", code: "Bangladesh" },
  { ISO: "BE", label: "Belgium", code: "Belgium" },
  { ISO: "BF", label: "Burkina Faso", code: "Burkina Faso" },
  { ISO: "BG", label: "Bulgaria", code: "Bulgaria" },
  { ISO: "BH", label: "Bahrain", code: "Bahrain" },
  { ISO: "BI", label: "Burundi", code: "Burundi" },
  { ISO: "BJ", label: "Benin", code: "Benin" },
  { ISO: "BL", label: "Saint Barthelemy", code: "Saint Barthelemy" },
  { ISO: "BM", label: "Bermuda", code: "Bermuda" },
  { ISO: "BN", label: "Brunei Darussalam", code: "Brunei Darussalam" },
  { ISO: "BO", label: "Bolivia", code: "Bolivia" },
  { ISO: "BR", label: "Brazil", code: "Brazil" },
  { ISO: "BS", label: "Bahamas", code: "Bahamas" },
  { ISO: "BT", label: "Bhutan", code: "Bhutan" },
  { ISO: "BV", label: "Bouvet Island", code: "Bouvet Island" },
  { ISO: "BW", label: "Botswana", code: "Botswana" },
  { ISO: "BY", label: "Belarus", code: "Belarus" },
  { ISO: "BZ", label: "Belize", code: "Belize" },
  { ISO: "CA", label: "Canada", code: "Canada" },
  {
    ISO: "CC",
    label: "Cocos (Keeling) Islands",
    code: "Cocos (Keeling) Islands",
  },
  {
    ISO: "CD",
    label: "Congo, Democratic Republic of the",
    code: "Congo, Democratic Republic of the",
  },
  {
    ISO: "CF",
    label: "Central African Republic",
    code: "Central African Republic",
  },
  {
    ISO: "CG",
    label: "Congo, Republic of the",
    code: "Congo, Republic of the",
  },
  { ISO: "CH", label: "Switzerland", code: "Switzerland" },
  { ISO: "CI", label: "Cote d'Ivoire", code: "Cote d'Ivoire" },
  { ISO: "CK", label: "Cook Islands", code: "Cook Islands" },
  { ISO: "CL", label: "Chile", code: "Chile" },
  { ISO: "CM", label: "Cameroon", code: "Cameroon" },
  { ISO: "CN", label: "China", code: "China" },
  { ISO: "CO", label: "Colombia", code: "Colombia" },
  { ISO: "CR", label: "Costa Rica", code: "Costa Rica" },
  { ISO: "CU", label: "Cuba", code: "Cuba" },
  { ISO: "CV", label: "Cape Verde", code: "Cape Verde" },
  { ISO: "CW", label: "Curacao", code: "Curacao" },
  { ISO: "CX", label: "Christmas Island", code: "Christmas Island" },
  { ISO: "CY", label: "Cyprus", code: "Cyprus" },
  { ISO: "CZ", label: "Czech Republic", code: "Czech Republic" },
  { ISO: "DE", label: "Germany", code: "Germany" },
  { ISO: "DJ", label: "Djibouti", code: "Djibouti" },
  { ISO: "DK", label: "Denmark", code: "Denmark" },
  { ISO: "DM", label: "Dominica", code: "Dominica" },
  { ISO: "DO", label: "Dominican Republic", code: "Dominican Republic" },
  { ISO: "DZ", label: "Algeria", code: "Algeria" },
  { ISO: "EC", label: "Ecuador", code: "Ecuador" },
  { ISO: "EE", label: "Estonia", code: "Estonia" },
  { ISO: "EG", label: "Egypt", code: "Egypt" },
  { ISO: "EH", label: "Western Sahara", code: "Western Sahara" },
  { ISO: "ER", label: "Eritrea", code: "Eritrea" },
  { ISO: "ES", label: "Spain", code: "Spain" },
  { ISO: "ET", label: "Ethiopia", code: "Ethiopia" },
  { ISO: "FI", label: "Finland", code: "Finland" },
  { ISO: "FJ", label: "Fiji", code: "Fiji" },
  {
    ISO: "FK",
    label: "Falkland Islands (Malvinas)",
    code: "Falkland Islands (Malvinas)",
  },
  {
    ISO: "FM",
    label: "Micronesia, Federated States of",
    code: "Micronesia, Federated States of",
  },
  { ISO: "FO", label: "Faroe Islands", code: "Faroe Islands" },
  { ISO: "FR", label: "France", code: "France" },
  { ISO: "GA", label: "Gabon", code: "Gabon" },
  { ISO: "GB", label: "United Kingdom", code: "United Kingdom" },
  { ISO: "GD", label: "Grenada", code: "Grenada" },
  { ISO: "GE", label: "Georgia", code: "Georgia" },
  { ISO: "GF", label: "French Guiana", code: "French Guiana" },
  { ISO: "GG", label: "Guernsey", code: "Guernsey" },
  { ISO: "GH", label: "Ghana", code: "Ghana" },
  { ISO: "GI", label: "Gibraltar", code: "Gibraltar" },
  { ISO: "GL", label: "Greenland", code: "Greenland" },
  { ISO: "GM", label: "Gambia", code: "Gambia" },
  { ISO: "GN", label: "Guinea", code: "Guinea" },
  { ISO: "GP", label: "Guadeloupe", code: "Guadeloupe" },
  { ISO: "GQ", label: "Equatorial Guinea", code: "Equatorial Guinea" },
  { ISO: "GR", label: "Greece", code: "Greece" },
  {
    ISO: "GS",
    label: "South Georgia and the South Sandwich Islands",
    code: "South Georgia and the South Sandwich Islands",
  },
  { ISO: "GT", label: "Guatemala", code: "Guatemala" },
  { ISO: "GU", label: "Guam", code: "Guam" },
  { ISO: "GW", label: "Guinea-Bissau", code: "Guinea-Bissau" },
  { ISO: "GY", label: "Guyana", code: "Guyana" },
  { ISO: "HK", label: "Hong Kong", code: "Hong Kong" },
  {
    ISO: "HM",
    label: "Heard Island and McDonald Islands",
    code: "Heard Island and McDonald Islands",
  },
  { ISO: "HN", label: "Honduras", code: "Honduras" },
  { ISO: "HR", label: "Croatia", code: "Croatia" },
  { ISO: "HT", label: "Haiti", code: "Haiti" },
  { ISO: "HU", label: "Hungary", code: "Hungary" },
  { ISO: "ID", label: "Indonesia", code: "Indonesia" },
  { ISO: "IE", label: "Ireland", code: "Ireland" },
  { ISO: "IL", label: "Israel", code: "Israel" },
  { ISO: "IM", label: "Isle of Man", code: "Isle of Man" },
  { ISO: "IN", label: "India", code: "India" },
  {
    ISO: "IO",
    label: "British Indian Ocean Territory",
    code: "British Indian Ocean Territory",
  },
  { ISO: "IQ", label: "Iraq", code: "Iraq" },
  {
    ISO: "IR",
    label: "Iran, Islamic Republic of",
    code: "Iran, Islamic Republic of",
  },
  { ISO: "IS", label: "Iceland", code: "Iceland" },
  { ISO: "IT", label: "Italy", code: "Italy" },
  { ISO: "JE", label: "Jersey", code: "Jersey" },
  { ISO: "JM", label: "Jamaica", code: "Jamaica" },
  { ISO: "JO", label: "Jordan", code: "Jordan" },
  { ISO: "JP", label: "Japan", code: "Japan" },
  { ISO: "KE", label: "Kenya", code: "Kenya" },
  { ISO: "KG", label: "Kyrgyzstan", code: "Kyrgyzstan" },
  { ISO: "KH", label: "Cambodia", code: "Cambodia" },
  { ISO: "KI", label: "Kiribati", code: "Kiribati" },
  { ISO: "KM", label: "Comoros", code: "Comoros" },
  { ISO: "KN", label: "Saint Kitts and Nevis", code: "Saint Kitts and Nevis" },
  {
    ISO: "KP",
    label: "Korea, Democratic People's Republic of",
    code: "Korea, Democratic People's Republic of",
  },
  { ISO: "KR", label: "Korea, Republic of", code: "Korea, Republic of" },
  { ISO: "KW", label: "Kuwait", code: "Kuwait" },
  { ISO: "KY", label: "Cayman Islands", code: "Cayman Islands" },
  { ISO: "KZ", label: "Kazakhstan", code: "Kazakhstan" },
  {
    ISO: "LA",
    label: "Lao People's Democratic Republic",
    code: "Lao People's Democratic Republic",
  },
  { ISO: "LB", label: "Lebanon", code: "Lebanon" },
  { ISO: "LC", label: "Saint Lucia", code: "Saint Lucia" },
  { ISO: "LI", label: "Liechtenstein", code: "Liechtenstein" },
  { ISO: "LK", label: "Sri Lanka", code: "Sri Lanka" },
  { ISO: "LR", label: "Liberia", code: "Liberia" },
  { ISO: "LS", label: "Lesotho", code: "Lesotho" },
  { ISO: "LT", label: "Lithuania", code: "Lithuania" },
  { ISO: "LU", label: "Luxembourg", code: "Luxembourg" },
  { ISO: "LV", label: "Latvia", code: "Latvia" },
  { ISO: "LY", label: "Libya", code: "Libya" },
  { ISO: "MA", label: "Morocco", code: "Morocco" },
  { ISO: "MC", label: "Monaco", code: "Monaco" },
  { ISO: "MD", label: "Moldova, Republic of", code: "Moldova, Republic of" },
  { ISO: "ME", label: "Montenegro", code: "Montenegro" },
  {
    ISO: "MF",
    label: "Saint Martin (French part)",
    code: "Saint Martin (French part)",
  },
  { ISO: "MG", label: "Madagascar", code: "Madagascar" },
  { ISO: "MH", label: "Marshall Islands", code: "Marshall Islands" },
  {
    ISO: "MK",
    label: "Macedonia, the Former Yugoslav Republic of",
    code: "Macedonia, the Former Yugoslav Republic of",
  },
  { ISO: "ML", label: "Mali", code: "Mali" },
  { ISO: "MM", label: "Myanmar", code: "Myanmar" },
  { ISO: "MN", label: "Mongolia", code: "Mongolia" },
  { ISO: "MO", label: "Macao", code: "Macao" },
  {
    ISO: "MP",
    label: "Northern Mariana Islands",
    code: "Northern Mariana Islands",
  },
  { ISO: "MQ", label: "Martinique", code: "Martinique" },
  { ISO: "MR", label: "Mauritania", code: "Mauritania" },
  { ISO: "MS", label: "Montserrat", code: "Montserrat" },
  { ISO: "MT", label: "Malta", code: "Malta" },
  { ISO: "MU", label: "Mauritius", code: "Mauritius" },
  { ISO: "MV", label: "Maldives", code: "Maldives" },
  { ISO: "MW", label: "Malawi", code: "Malawi" },
  { ISO: "MX", label: "Mexico", code: "Mexico" },
  { ISO: "MY", label: "Malaysia", code: "Malaysia" },
  { ISO: "MZ", label: "Mozambique", code: "Mozambique" },
  { ISO: "NA", label: "Namibia", code: "Namibia" },
  { ISO: "NC", label: "New Caledonia", code: "New Caledonia" },
  { ISO: "NE", label: "Niger", code: "Niger" },
  { ISO: "NF", label: "Norfolk Island", code: "Norfolk Island" },
  { ISO: "NG", label: "Nigeria", code: "Nigeria" },
  { ISO: "NI", label: "Nicaragua", code: "Nicaragua" },
  { ISO: "NL", label: "Netherlands", code: "Netherlands" },
  { ISO: "NO", label: "Norway", code: "Norway" },
  { ISO: "NP", label: "Nepal", code: "Nepal" },
  { ISO: "NR", label: "Nauru", code: "Nauru" },
  { ISO: "NU", label: "Niue", code: "Niue" },
  { ISO: "NZ", label: "New Zealand", code: "New Zealand" },
  { ISO: "OM", label: "Oman", code: "Oman" },
  { ISO: "PA", label: "Panama", code: "Panama" },
  { ISO: "PE", label: "Peru", code: "Peru" },
  { ISO: "PF", label: "French Polynesia", code: "French Polynesia" },
  { ISO: "PG", label: "Papua New Guinea", code: "Papua New Guinea" },
  { ISO: "PH", label: "Philippines", code: "Philippines" },
  { ISO: "PK", label: "Pakistan", code: "Pakistan" },
  { ISO: "PL", label: "Poland", code: "Poland" },
  {
    ISO: "PM",
    label: "Saint Pierre and Miquelon",
    code: "Saint Pierre and Miquelon",
  },
  { ISO: "PN", label: "Pitcairn", code: "Pitcairn" },
  { ISO: "PR", label: "Puerto Rico", code: "Puerto Rico" },
  { ISO: "PS", label: "Palestine, State of", code: "Palestine, State of" },
  { ISO: "PT", label: "Portugal", code: "Portugal" },
  { ISO: "PW", label: "Palau", code: "Palau" },
  { ISO: "PY", label: "Paraguay", code: "Paraguay" },
  { ISO: "QA", label: "Qatar", code: "Qatar" },
  { ISO: "RE", label: "Reunion", code: "Reunion" },
  { ISO: "RO", label: "Romania", code: "Romania" },
  { ISO: "RS", label: "Serbia", code: "Serbia" },
  { ISO: "RU", label: "Russian Federation", code: "Russian Federation" },
  { ISO: "RW", label: "Rwanda", code: "Rwanda" },
  { ISO: "SA", label: "Saudi Arabia", code: "Saudi Arabia" },
  { ISO: "SB", label: "Solomon Islands", code: "Solomon Islands" },
  { ISO: "SC", label: "Seychelles", code: "Seychelles" },
  { ISO: "SD", label: "Sudan", code: "Sudan" },
  { ISO: "SE", label: "Sweden", code: "Sweden" },
  { ISO: "SG", label: "Singapore", code: "Singapore" },
  { ISO: "SH", label: "Saint Helena", code: "Saint Helena" },
  { ISO: "SI", label: "Slovenia", code: "Slovenia" },
  {
    ISO: "SJ",
    label: "Svalbard and Jan Mayen",
    code: "Svalbard and Jan Mayen",
  },
  { ISO: "SK", label: "Slovakia", code: "Slovakia" },
  { ISO: "SL", label: "Sierra Leone", code: "Sierra Leone" },
  { ISO: "SM", label: "San Marino", code: "San Marino" },
  { ISO: "SN", label: "Senegal", code: "Senegal" },
  { ISO: "SO", label: "Somalia", code: "Somalia" },
  { ISO: "SR", label: "Suriname", code: "Suriname" },
  { ISO: "SS", label: "South Sudan", code: "South Sudan" },
  { ISO: "ST", label: "Sao Tome and Principe", code: "Sao Tome and Principe" },
  { ISO: "SV", label: "El Salvador", code: "El Salvador" },
  {
    ISO: "SX",
    label: "Sint Maarten (Dutch part)",
    code: "Sint Maarten (Dutch part)",
  },
  { ISO: "SY", label: "Syrian Arab Republic", code: "Syrian Arab Republic" },
  { ISO: "SZ", label: "Swaziland", code: "Swaziland" },
  {
    ISO: "TC",
    label: "Turks and Caicos Islands",
    code: "Turks and Caicos Islands",
  },
  { ISO: "TD", label: "Chad", code: "Chad" },
  {
    ISO: "TF",
    label: "French Southern Territories",
    code: "French Southern Territories",
  },
  { ISO: "TG", label: "Togo", code: "Togo" },
  { ISO: "TH", label: "Thailand", code: "Thailand" },
  { ISO: "TJ", label: "Tajikistan", code: "Tajikistan" },
  { ISO: "TK", label: "Tokelau", code: "Tokelau" },
  { ISO: "TL", label: "Timor-Leste", code: "Timor-Leste" },
  { ISO: "TM", label: "Turkmenistan", code: "Turkmenistan" },
  { ISO: "TN", label: "Tunisia", code: "Tunisia" },
  { ISO: "TO", label: "Tonga", code: "Tonga" },
  { ISO: "TR", label: "Turkey", code: "Turkey" },
  { ISO: "TT", label: "Trinidad and Tobago", code: "Trinidad and Tobago" },
  { ISO: "TV", label: "Tuvalu", code: "Tuvalu" },
  {
    ISO: "TW",
    label: "Taiwan",
    code: "Taiwan",
  },
  {
    ISO: "TZ",
    label: "United Republic of Tanzania",
    code: "United Republic of Tanzania",
  },
  { ISO: "UA", label: "Ukraine", code: "Ukraine" },
  { ISO: "UG", label: "Uganda", code: "Uganda" },
  { ISO: "US", label: "United States", code: "United States" },
  { ISO: "UY", label: "Uruguay", code: "Uruguay" },
  { ISO: "UZ", label: "Uzbekistan", code: "Uzbekistan" },
  {
    ISO: "VA",
    label: "Holy See (Vatican City State)",
    code: "Holy See (Vatican City State)",
  },
  {
    ISO: "VC",
    label: "Saint Vincent and the Grenadines",
    code: "Saint Vincent and the Grenadines",
  },
  { ISO: "VE", label: "Venezuela", code: "Venezuela" },
  {
    ISO: "VG",
    label: "British Virgin Islands",
    code: "British Virgin Islands",
  },
  { ISO: "VI", label: "US Virgin Islands", code: "US Virgin Islands" },
  { ISO: "VN", label: "Vietnam", code: "Vietnam" },
  { ISO: "VU", label: "Vanuatu", code: "Vanuatu" },
  { ISO: "WF", label: "Wallis and Futuna", code: "Wallis and Futuna" },
  { ISO: "WS", label: "Samoa", code: "Samoa" },
  { ISO: "XK", label: "Kosovo", code: "Kosovo" },
  { ISO: "YE", label: "Yemen", code: "Yemen" },
  { ISO: "YT", label: "Mayotte", code: "Mayotte" },
  { ISO: "ZA", label: "South Africa", code: "South Africa" },
  { ISO: "ZM", label: "Zambia", code: "Zambia" },
  { ISO: "ZW", label: "Zimbabwe", code: "Zimbabwe" },
];

// Sort countries by name
countries.sort((a, b) => a.label.localeCompare(b.label));

export default countries;
